import './style.css';
import App from './App.vue';
import { createApp } from 'vue';
import { lenis, raf } from './scroll';

// smooth scroll handled in scroll.ts

const app = createApp(App);
app.mount('#app');

export { raf, lenis };
